'use client';

import { createClient } from '@/lib/supabase/client';
import { Button } from '@ui/components/ui/button';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import Image from 'next/image';

export default function GoogleAuthButton() {
  const t = useTranslations('Form');
  const tCommon = useTranslations('Common');

  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSocialLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      const supabase = createClient();
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${process.env.NEXT_PUBLIC_SITE_URL}/auth/callback`,
        },
      });

      if (error) throw error;
    } catch (error: unknown) {
      console.error('Google auth error:', error);
      setError(error instanceof Error ? error.message : t('common.errorOccurred'));
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSocialLogin}>
      <div className="flex flex-col gap-6">
        {error && <p className="text-sm text-destructive-500">{error}</p>}
        <Button type="submit" className="w-full bg-white text-gray-800 hover:bg-gray-100 border border-gray-300" disabled={isLoading}>
          <Image src="/google.svg" alt="Google logo" width={20} height={20} className="inline mr-2" />
          {isLoading ? tCommon('states.loading') : t('logIn.continueWithGoogle')}
        </Button>
      </div>
    </form>
  );
}
